import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LotResponseDto } from '../schemas/lot-response.dto';
import { CreateLotRequestDto } from '../schemas/create-lot-request.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { UpdateLotRequestDto } from '../schemas/update-lot-request.dto';
import { FinalizeLotRequestDto } from '../schemas/finalize-lot-request.dto';
import { CreateLotsWithExcelRequestDto } from '../schemas/create-lots-with-excel-request.dto';

@Injectable({ providedIn: 'root' })
export class LotAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/LotAdmin`;

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<LotResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<LotResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    create(payload: CreateLotRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/create`)
            .post(payload)
            .json<LotResponseDto>()
            .build()
            .send();
    }

    createWithExcel(request: CreateLotsWithExcelRequestDto, file: File) {
        const formData = new FormData();
        formData.append('tradingProcedureId', String(request.tradingProcedureId));
        formData.append('file', file);

        return this.builder
            .url(`${this.controllerUrl}/createWithExcel`)
            .post(formData)
            .json<LotResponseDto[]>()
            .build()
            .send();
    }

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }

    update(payload: UpdateLotRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/update`)
            .patch(payload)
            .json<LotResponseDto>()
            .build()
            .send();
    }

    finalizeLot(payload: FinalizeLotRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/finalizeLot`)
            .patch(payload)
            .json<LotResponseDto>()
            .build()
            .send();
    }
}
